import { useAtom } from 'jotai'
import { useState, useRef, useEffect } from 'react'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import { initialLoadingAtom } from 'src/common/stores/store'
import { useActiveWalletConnectionStatus } from 'thirdweb/react'

export const useInitialLoading = () => {
  const { smartAccountInfo } = useSmartAccount()
  const walletStatus = useActiveWalletConnectionStatus()
  const [initialLoading, setInitialLoading] = useAtom(initialLoadingAtom)
  const walletInitializedRef = useRef(false)
  const [initTimePassed, setInitTimePassed] = useState(false)
  useEffect(() => {
    if (initialLoading && !initTimePassed) {
      if (walletStatus === 'connecting') {
        setInitTimePassed(true)
      } else {
        const timeout = setTimeout(() => {
          setInitTimePassed(true)
        }, 500)
        return () => {
          clearTimeout(timeout)
        }
      }
    }
  }, [initialLoading, initTimePassed, walletStatus])
  useEffect(() => {
    if (initialLoading && initTimePassed && !walletInitializedRef.current) {
      if (walletStatus === 'disconnected') {
        walletInitializedRef.current = true
        setTimeout(() => setInitialLoading(false), 500)
      } else if (walletStatus === 'connected' && smartAccountInfo) {
        walletInitializedRef.current = true
        setTimeout(() => setInitialLoading(false), 500)
      }
    }
  }, [initialLoading, walletStatus, initTimePassed, smartAccountInfo, setInitialLoading])

  return initialLoading
}
